import { LanguageCode, Locale, PointOfSale } from '@flysas-tech/book-value-stream-models';
import { Optional, Static, Intersect, Object as TObject, Omit, String } from '@sinclair/typebox';

import { Channel } from '../../schemas/sas-domain';
import { StringEnumSchema } from '../../utils';

const uniqueMarkets = new Set(Object.values(Locale).map(v => v.split('-')[1]));
const markets = Array.from(uniqueMarkets);

const localePattern = `^(?:${Object.values(LanguageCode).join('|')})(?:-(?:${markets.join('|')}))?$`;

export const LocaleSchema = String({
  pattern: localePattern,
  description: 'Validating language and market separately, instead of combinations ',
});

export type RequestHeaders = Static<typeof RequestHeaders>;
export const RequestHeaders = TObject({
  'content-type': Optional(String()),
  'accept-language': Optional(String({ description: 'Deprecated, use language and locale instead' })),
  language: Optional(StringEnumSchema(LanguageCode)),
  locale: Optional(LocaleSchema),
  'sas-user-session-id': String({
    description: 'Tracking id for a user journey',
  }),
  'sas-correlation-id': Optional(
    String({
      description: 'Tracking id for a single request',
    })
  ),
  channel: StringEnumSchema(Channel, '"Client type", so we can differ between officeId for WEB or APP'),
});

export type OrderForMmbRequestHeaders = Static<typeof OrderForMmbRequestHeaders>;
export const OrderForMmbRequestHeaders = TObject({
  'content-type': Optional(String()),
});

export type RevenueCallBackHeaders = Static<typeof RevenueCallBackHeaders>;
export const RevenueCallBackHeaders = Intersect([
  Omit(RequestHeaders, ['accept-language']),
  TObject({
    language: StringEnumSchema(LanguageCode),
  }),
]);

export type RevenueRequestHeader = Static<typeof RevenueRequestHeader>;
export const RevenueRequestHeader = Intersect([
  Omit(RequestHeaders, ['accept-language']),
  TObject({
    language: StringEnumSchema(LanguageCode),
    locale: StringEnumSchema(Locale),
    pos: StringEnumSchema(PointOfSale),
  }),
]);
